import useForm from 'hooks/useForm'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import dashboardApi from 'services/api/dashboard'

import { getSubsidiaryList } from '../../actions/index'
import Dialog from '../../components/ReusableComponents/Dialog/index'
import CustomHeader from '../../components/ReusableComponents/HeaderTitles/index'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import BookingEngine from './BookingEngine/index'
import BottomBar from './BottomBar/index'
import { ReactComponent as ErrorIcon } from './error.svg'
import styles from './NewHotel.module.scss'
import ParentAndChain from './ParentAndChain/index'
import Services from './Services/index'
import SubmittedDialog from './SubmittedDialog/index'

const NewHotel = () => {
  const [step, setStep] = useState(1)

  const [isNewHotelPosting, setIsNewHotelPosting] = useState(false)
  const [postResponse, setPostResponse] = useState()
  const [addHotelError, setAddHotelError] = useState()
  const [parentStepValid, setParentStepValid] = useState(false)
  const [beStepValid, setBeStepValid] = useState(false)
  const [servicesStepValid, setServicesStepValid] = useState(false)
  const [isNextDisabled, setNextDisabled] = useState(true)

  async function postNewHotel(postData) {
    setIsNewHotelPosting(true)

    dashboardApi.addHotel(postData).then(
      data => {
        setIsNewHotelPosting(false)
        setPostResponse(data)
      },
      err => {
        setIsNewHotelPosting(false)
        setAddHotelError(err.message)
      }
    )
  }

  const [subscriptions, setSubscriptions] = useState({
    PlatformAccessFee: {
      plan: 'PlatformAccessFee',
      planRate: 0,
      isFlatMonthly: true,
      checked: true,
      startDate: null
    }
  })

  function setPlatformAccessFee(val) {
    setSubscriptions({
      PlatformAccessFee: {
        plan: 'PlatformAccessFee',
        planRate: val,
        isFlatMonthly: true,
        checked: true,
        startDate: null
      }
    })
  }

  const [formData, handleFormChange, setFormData] = useForm({
    merchantId: '',
    parentChainCode: '',
    chainCode: '',
    hotelName: '',
    bookingEngineLink: '',
    externalHotelId: '',
    bookingEngineSlug: '',
    bookingEngine: '',
    pms: '',
    city: '',
    stateCode: '',
    countryCode: '',
    numberOfRooms: '',
    postalCode: '',
    streetAddress: '',
    placesId: '',
    HostMessagingAuthorizingPartyFullName: null,
    pmsHotelId: ''
  })

  const [postData, setPostData] = useState()

  const dispatch = useDispatch()

  useEffect(() => {
    const postData = {
      ...formData,
      subsidiarySubscriptions: [
        ...Object.values(subscriptions)
          .filter(s => s.checked)
          // eslint-disable-next-line no-unused-vars
          .map(({ checked, ...rest }) => ({
            ...rest
          }))
      ]
    }

    setPostData(postData)
  }, [formData, subscriptions])

  useEffect(() => {
    if (step === 1) {
      setNextDisabled(!parentStepValid)
    }

    if (step === 2) {
      setNextDisabled(!(parentStepValid && beStepValid))
    }

    if (step === 3) {
      setNextDisabled(!(parentStepValid && beStepValid && servicesStepValid))
    }
  }, [step, parentStepValid, beStepValid, servicesStepValid])

  const [hotelSubmitted, setHotelSubmitted] = useState()

  function handleNext() {
    if (step < 3) {
      setStep(s => s + 1)
    } else {
      postNewHotel(postData)
    }
  }

  useEffect(() => {
    if (postResponse) {
      setHotelSubmitted(true)
      dispatch(getSubsidiaryList())
    }
  }, [dispatch, postResponse])

  const errorRef = useRef()

  useEffect(() => {
    if (addHotelError && Element.prototype.scrollIntoView && errorRef.current) {
      setTimeout(() => {
        if (errorRef.current) {
          errorRef.current.scrollIntoView({ behavior: 'smooth' })
        }
      }, 0)
    }
  }, [errorRef, addHotelError])

  return (
    <div className={styles.wrapper}>
      <CustomHeader
        title={step > 2 ? `Add "${formData.hotelName}"` : 'Add new hotel'}
        width={830}
        isFixed
      />
      {addHotelError && (
        <div ref={errorRef} className={styles.formError}>
          <ErrorIcon />
          {addHotelError}
        </div>
      )}
      <ParentAndChain
        formData={formData}
        handleFormChange={handleFormChange}
        setFormData={setFormData}
        handleValidated={setParentStepValid}
        done={parentStepValid}
      />
      <BookingEngine
        disabled={step < 2}
        formData={formData}
        handleFormChange={handleFormChange}
        setFormData={setFormData}
        handleValidated={setBeStepValid}
        done={beStepValid}
      />
      <Services
        disabled={step < 3}
        platformAccessFee={subscriptions.PlatformAccessFee.planRate}
        setPlatformAccessFee={setPlatformAccessFee}
        handleValidated={setServicesStepValid}
        done={servicesStepValid}
        hostMessagingAuthorizingPartyFullName={
          formData.HostMessagingAuthorizingPartyFullName
        }
        setHostedMessagingData={newName =>
          setFormData({ ...formData, HostMessagingAuthorizingPartyFullName: newName })
        }
      />
      <BottomBar
        buttonLabel={step === 3 ? 'Save hotel' : 'Next step'}
        handleNext={handleNext}
        nextDisabled={isNextDisabled}
      />
      {isNewHotelPosting && (
        <Dialog>
          <LoadingIndicator white />
        </Dialog>
      )}
      {hotelSubmitted && (
        <SubmittedDialog hotelName={postResponse && postResponse.hotelName} />
      )}
    </div>
  )
}

export default NewHotel
